import React from "react";
import { cn } from "../../lib/utils";

interface PageLayoutProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  hack?: React.ReactNode;
}

const PageLayout = React.forwardRef<HTMLElement, PageLayoutProps>(
  ({ as: Comp = "div", className, hack, children, ...props }, ref) => {
    return (
      // This is the outer wrapper, handling responsive margins.
      <div className="h-full flex flex-col relative mx-0 md:mx-4">
        {/* This is the inner "book" element, handling responsive borders and shadows. */}
        <Comp
          ref={ref}
          className={cn(
            // Base styles (mobile-first)
            "relative bg-page-bg flex-grow flex flex-col border-black mb-0",
            // Mobile styles from form-book and styles-mobile.css
            "shadow-none border-x-0 border-y-8",
            // Tablet/Desktop styles (sm breakpoint is 640px)
            "sm:shadow-aesthetic sm:border-x-8",
            className
          )}
          {...props}
        >
          {children}
        </Comp>
        {/* The 'hack' prop for absolutely positioned elements */}
        {hack}
      </div>
    );
  }
);

PageLayout.displayName = "PageLayout";

export default PageLayout;
